import { FaFileWord, FaFileExcel, FaFilePdf, FaFileCsv, FaFileVideo, FaFileImage, FaLink } from "react-icons/fa";
import { BiSolidFileGif } from "react-icons/bi";
import { FiFileText } from "react-icons/fi";

export const getFileIcon = (extension: string) => {
  switch (extension.toLowerCase()) {
    case ".link":
      return <FaLink size={16} color="#3a3a3a" />;
    case ".doc":
    case ".docx":
      return <FaFileWord size={24} color="#1E88E5" />;
    case ".pdf":
      return <FaFilePdf size={24} color="#FF5252" />;
    case ".xlsx":
    case ".xls":
      return <FaFileExcel size={24} color="#4CAF50" />;
    case ".csv":
      return <FaFileCsv size={24} color="#FF9800" />;
    case ".mp4":
    case ".mov":
    case ".avi":
      return <FaFileVideo size={24} color="#FF5722" />;
    case ".jpeg":
    case ".jpg":
    case ".png":
    case ".bmp":
    case ".tiff":
    case ".webp":
    case ".svg":
      return <FaFileImage size={24} color="#03A9F4" />;
    case ".gif":
      return <BiSolidFileGif size={24} color="#FF4081" />;
    case ".txt":
      return <FiFileText size={24} color="#8E8E8E" />;
    case ".ai":
      return <FaFileImage size={24} color="#FFAB40" />;
    case ".mondaydoc":
    case "mondaydoc":
      return <img src="/img/monday-doc-icon_v2.svg" alt="Monday Doc" className="w-6 h-6" />;
    default:
      return <FaFileImage size={24} color="#03A9F4" />;
  }
};
